export enum StorageKeys {
  ACCESS_TOKEN = "access_token",
  REFRESH_TOKEN = "refresh_token",
  BASE_CURRENCY = "base_currency",
  RECEIVABLE_ACCOUNT = "receivable_account",
  DECIMAL_POINT = "dp",
}
